export default __webpack_public_path__ + "static/media/tete49.cfe513df.png";